<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-141 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner">
                        <h3 class="archive-title">Zertifizierungsverlauf</h3>
                        <div class="table-wrapper">
                            <table>
                                <tr>
                                    <th>Datum</th>
                                    <th>Veranstaltung</th>
                                    <th>Veranstaltungs-ort</th>
                                    <th>Typ</th>
                                    <th>Zahlung</th>
                                    <th>Anmeldung</th>
                                    <th>Zertifikat-Download</th>
                                </tr>
                                <tr *ngFor="let kursTeilnehmer of kursTeilnehmerListe">
                                    <td>{{ kursTeilnehmer.kurs.datum | date: "dd.MM.yyyy" }}</td>
                                    <td>{{ titel(kursTeilnehmer.kurs.typ!) }}</td>
                                    <td>{{ getKursort(kursTeilnehmer.kurs) }}</td>
                                    <td class="data-align">{{ zertifizierungstyp[kursTeilnehmer.zertifizierungstyp!] }}</td>
                                    <td class="data-align">{{ getZahlung(kursTeilnehmer) }}</td>
                                    <td class="data-align">
                                        {{ getAnmeldestatus(kursTeilnehmer) }}
                                        <button class="btn btn-default" *ngIf="!getAnmeldestatus(kursTeilnehmer)" (click)="setVisible(kursTeilnehmer)">Storno</button>
                                    </td>
                                    <td>
                                        <button class="btn btn-primary zertifikat" [disabled]="!kursTeilnehmer.zertifikatVorhanden" (click)="zertifikatHerunterladen(kursTeilnehmer)">Herunterladen</button>
                                    </td>
                                </tr>
                            </table>
                        </div> <!-- /.widget-inner -->
                    </div> <!-- /.widget-main -->
                </div>
            </div> <!-- /.col-md-12 -->
        </div> <!-- /.row -->
    </div>
</div>

<p-dialog [(visible)]="visible" [showHeader]="false" [modal]="true" [draggable]="false">
    <div class="wrapper">
        <div>
            <div class="modal-header">
                <h4 class="modal-title"><strong>Bestätigung</strong></h4>
            </div>
            <div class="modal-body">
                <p class="text">Wollen Sie jetzt rechtsverbindlich stornieren?</p>
                <p class="achtung-text"><b>ACHTUNG:</b> es können dadurch <a
                    routerLink="/kosten-storno">Stornokosten</a>
                    entstehen!</p>
            </div>
            <div class="modal-footer">
                <p-button label="Nein" (click)="visible = false" class="nein-button"></p-button>
                <p-button label="Ja" (onClick)="stornieren()" class="storno-btn"></p-button>
            </div>
        </div>
    </div>
</p-dialog>
